export default __webpack_public_path__ + "static/media/TETU.36421847.svg";